// extracted by mini-css-extract-plugin
export default {"visibilityButton":"InputPasswordButton_visibilityButton__sj2ok","withLabel":"InputPasswordButton_withLabel__DBrmT"};